import { useMemo } from "react";
import { shallowEqual } from "react-redux";
import { IInputBox } from "pages/OrderModal/components/DstAddress/types";
import { useAppSelector } from "store/hooks/useAppSelector";
import { createCarIcon, createLocationIcon } from "./constants";

const useMapIcons = () => {
  const accentColor = useAppSelector(
    (state) => state.settings.config.accentColor.main,
    shallowEqual,
  );

  const icons = useMemo(
    () => ({
      startPointIcon: createLocationIcon(accentColor, "A"),
      secondPointIcon: createLocationIcon(accentColor, "B"),
      thirdPointIcon: createLocationIcon(accentColor, "C"),
      finishPointIcon: createLocationIcon(accentColor, "D"),
      carIcon: createCarIcon(accentColor),
    }),
    [accentColor],
  );

  const generateIcon = (boxes: IInputBox[], index: number) => {
    if (boxes.length === 2) {
      return index === 0 ? icons.secondPointIcon : icons.thirdPointIcon;
    } else if (boxes.length === 3) {
      return index === 0
        ? icons.secondPointIcon
        : index === 1
        ? icons.thirdPointIcon
        : icons.finishPointIcon;
    }
    return icons.secondPointIcon;
  };

  return { ...icons, generateIcon };
};

export default useMapIcons;
